import React, { useMemo } from "react"

export const withFooterBackToTop = Component =>
  React.memo(({ name = "FooterBackToTop" }) => {
    const text = "Beam me up, Scotty! — No trace of intelligent life down here…"

    const handleClick = () => {
      window.scrollTo(0, 0)
    }

    Component.displayName = name
    return useMemo(() => <Component text={text} onClickIcon={handleClick} />, [text])
  })
